export {
  // Export the API
  api as analyticsApi,
  useGetAnalyticsOverviewQuery as useGetAnalyticsOverviewQueryLegacy,
  // Re-export query hooks from generated file
  useGetAnalyticsQuery as useGetAnalyticsQueryLegacy,
  useLazyGetAnalyticsOverviewQuery,
  useLazyGetAnalyticsQuery,
  type GetAnalyticsOverviewQuery,
  type GetAnalyticsOverviewQueryVariables,
  // Re-export types from generated file
  type GetAnalyticsQuery,
  type GetAnalyticsQueryVariables,
} from './operations.generated';
